import { memo } from 'react';

export interface BrandMarkProps {
  size?: number;
}

/**
 * The MarkGlass mark: a document with a reading glass over it. Flat,
 * single-colour (currentColor) so it sits in the same icon system as every
 * other control in the toolbar instead of standing out as a decorative tile.
 *
 * Plain <svg>, not MUI's Box: Box's width/height props are meant to resolve
 * to CSS via its style-system layer, but that resolution has proven
 * unreliable for a non-standard host element like "svg" -- it can compute to
 * `width: auto; height: auto`, leaving the icon with no rendered size at
 * all. Real width/height attributes on a native element sidestep that.
 */
export const BrandMark = memo(function BrandMark({ size = 22 }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      style={{ flexShrink: 0, display: 'block' }}
    >
      <path
        d="M6.75 3h7.5l3 3v11.25a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5V4.5A1.5 1.5 0 0 1 6.75 3z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path d="M14.25 3v2.25a1.5 1.5 0 0 0 1.5 1.5h2.25" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <line x1="7.75" y1="10.5" x2="12.25" y2="10.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <circle cx="12.75" cy="14.75" r="2.65" stroke="currentColor" strokeWidth="1.3" />
      <line x1="14.6" y1="16.6" x2="16.75" y2="18.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
});

export default BrandMark;
